import React from 'react';// eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import reactMixin from 'react-mixin';
import styles from './ForgotPasswordPage.scss';
import baseComponent from '../../../decorators/baseComponent';
import ProgressButton from '../../ProgressButton';
import Context from '../../../Context';
import Header from '../../Header';
import BaseReactComponent from '../../Util/BaseReactComponent';
import * as LoginActions from '../../../actioncreators/LoginActions';
import {connect} from 'react-redux';
import {TextField} from 'material-ui';
import LinkedStateMixin from 'react-addons-linked-state-mixin';

@connect(state => ({
  inprogress: state.login.inprogress
}))
@baseComponent(styles)
@reactMixin.decorate(LinkedStateMixin)
class ForgotPasswordPage extends BaseReactComponent {

  constructor(props) {
    super(props);

    this.state = {};
    this.state.email = '';
    this.state.requestedPassword = false;
  }

  componentWillMount() {
    //this.props
  }

  keyup(e) {
    if (e.which === 13) {
      this.changePassword(e);
    }
  }

  setEmail = (event, email) => {
    this.setState({email:email});
  }

  changePassword(e) {
    if (e) {
      e.preventDefault();
    }

    let self = this;

    LoginActions.changePassword(self.state.email, function (err) {
      if (!err) {
        self.setState({
          requestedPassword: true
        });
      } else {
        console.log(err);
      }
    })(this.props.dispatch);
  }

  render() {
    let title = 'Wachtwoord vergeten';
    Context.getInstance().onSetTitle(title);

    let requestForm = (
      <form acceptCharset="UTF-8" className="require-validation clearfix" method="post"
            onKeyPress={this.keyup.bind(this)}>
        <div className="form-row clearfix">
          <div className="form-group required">

            <TextField id="username" className="inputfield" onChange={this.setEmail} floatingLabelText={this.getIntlMessage('forgotpasswordpage.email-label')} />

          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <ProgressButton className="form-control btn btn-primary submit-button" type="submit"
                            onClick={this.changePassword.bind(this)}>{this.getMessage('send-email-button')}</ProgressButton>
          </div>
        </div>
      </form>);

    let passwordRequestedMessage = (
      <div>
        <div
          className="ForgotPasswordPage-password-requested-message">{this.getMessage('password-requested-message')}</div>
        <div className="ForgotPasswordPage-send-to-email">{this.state.email}</div>
      </div>
    );

    return (
      <div className="ForgotPasswordPage">
        <Header pageName="forgotpasswordpage"/>

        <div className="ForgotPasswordPage-container">
          <div className="ForgotPasswordPage-container-background">
            <div className="row ForgotPasswordPage-header-row">
              <div className="col-xs-12">
                <h1 style={{padding: '0 16px'}}>{this.getMessage('title')}</h1>
              </div>
            </div>
            {this.state.requestedPassword ? passwordRequestedMessage : requestForm}
          </div>
        </div>
      </div>
    );
  }
}

ForgotPasswordPage.defaultProps = {
  componentName: 'forgotpasswordpage'
};

export default ForgotPasswordPage;



// WEBPACK FOOTER //
// /src/components/PasswordPage/ForgotPasswordPage/ForgotPasswordPage.js